import React from 'react'
import styled from 'styled-components'
import {
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import {
  colors,
  theme,
  svgIconStyle,
  StyledH5
} from '../../../theme/Global'

export const DataTableWrapper = styled.div`
  flex-direction: column;
  flex: 1 1 auto;
  align-content: stretch;
`

export const CustomTableHead = styled(TableHead)`
  background-color: ${colors.darkGrey};
`

export const CustomTableHeadRow = styled(TableRow)`
  && {
    height: 45px;
  }
`
export const CustomTableHeadLoadingRow = styled(TableRow)`
  && {
    height: 45px;
    background-color: ${colors.lightGrey};
  }
`

export const CustomTableHeadCell = styled(TableCell)`
  && {
    margin: 0;
    padding: 0;
    border-bottom: none;
  }
`

export const CustomTableBodyCell = styled(TableCell)`
  && {
    padding: 0 0 0 20px;
    text-align: left;
    vertical-align: top;
  }
`

export const CustomTableBodyRow = styled(TableRow)`
  && {
    border-bottom-color: ${colors.mediumGrey};
  }
`

export const CustomH5 = styled(StyledH5)`
  && {
    color: ${theme.colors.whiteText};
    cursor: pointer;
    font-size: 14px;
    margin: 0;
    padding: 0 0 0 20px;
    text-align: left;
    display: inline-block;
    position: relative;
    top: 0px;
  }
`

export const CustomArrowUp = (
  <ArrowDropUpIcon
    style={svgIconStyle({
      color: colors.white,
      height: '24px',
      width: '24px'
    })}
  />
)

export const CustomArrowDown = (
  <ArrowDropDownIcon
    style={svgIconStyle({
      color: colors.white,
      height: '24px',
      width: '24px'
    })}
  />
)
